'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgTrend(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8.635 8.162l2.204-2.072-.067-.062-.468-.44c-.2-.21-.245-.44-.111-.69.111-.252.334-.398.646-.398h2.47c.402 0 .691.293.691.67v2.343c-.022.272-.178.44-.423.544a.68.68 0 01-.712-.083 8.418 8.418 0 01-.468-.419c-.044-.042-.067-.084-.111-.125-.045.041-.09.062-.112.104-.912.858-1.847 1.716-2.76 2.595-.356.335-.846.398-1.247.168a.865.865 0 01-.223-.168L6.52 8.79c-.023-.02-.045-.062-.09-.104-.044.042-.088.063-.11.105l-2.605 2.448c-.401.335-.98.356-1.38.021-.401-.335-.446-.9-.112-1.276.022-.042.067-.063.089-.084l3.362-3.16c.311-.293.69-.377 1.09-.21.134.043.245.147.357.231.49.44.957.9 1.447 1.36.044-.02.044.021.067.042z", fill: "currentColor" }))));
}

module.exports = SvgTrend;
//# sourceMappingURL=Trend.js.map
